import { i18n } from 'i18n';
import { EMainRoutes } from 'shared/typings';

export const HEADER_TITLES = [
	{ key: EMainRoutes.DASHBOARD, title: i18n.t('Dashboard') },
	{ key: EMainRoutes.OFFERS, title: i18n.t('Offers') },
	{ key: `${EMainRoutes.OFFER}-${EMainRoutes.CREATE}`, title: i18n.t('Creating offer') },
	{ key: `${EMainRoutes.OFFER}-${EMainRoutes.EDIT}`, title: i18n.t('Edit offer') },
	{ key: `${EMainRoutes.OFFER}-${EMainRoutes.PREVIEW}`, title: i18n.t('Preview offer') },
	{ key: EMainRoutes.OFFER, title: i18n.t('Offer Page') },
	{ key: EMainRoutes.PORTFOLIO, title: i18n.t('Portfolio') },
	{ key: `${EMainRoutes.PORTFOLIO}-${EMainRoutes.CREATE}`, title: i18n.t('Creating a portfolio') },
	{ key: `${EMainRoutes.PORTFOLIO}-${EMainRoutes.PREVIEW}`, title: i18n.t('Preview portfolio') },
	{ key: `${EMainRoutes.PORTFOLIO}-${EMainRoutes.EDIT}`, title: i18n.t('Edit portfolio') },
	{ key: EMainRoutes.CLIENTS, title: i18n.t('Clients') },
	{ key: EMainRoutes.EARNINGS, title: i18n.t('Earnings') },
	{ key: EMainRoutes.DOCUMENTS, title: i18n.t('Documents') },
	{ key: EMainRoutes.CONTRACTORS, title: i18n.t('Contractors') },
	{ key: EMainRoutes.BALANCE, title: i18n.t('Balance') },
	{ key: EMainRoutes.LEGAL_INFO, title: i18n.t('Legal info') },
	{ key: EMainRoutes.REPORTS, title: i18n.t('Reports') },
];
